import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
// import { Button } from "@material-ui/core";
import MyDropzone from "components/Dropzone/MyDropzone";
import { DialogActions } from "@material-ui/core";
// import { Button } from "@material-ui/core";
// const percent = "100%";

const useStyles = makeStyles(styles);

export default function ImportDotDialog() {
  const text = {
    en: "Drag and drop the files here, or click and select",
    pt: "Arraste e solte os arquivos aqui, ou clique e selecione",
  };
  const { language } = useUser();
  const {
    // setDot,
    isActiveDialogImportDot,
    setActiveDialogImportDot,
    // setArrayElements,
  } = useDot();

  //   const [texts, setTexts] = useState([]);
  const [checked, setChecked] = useState(true);
  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleClose = () => {
    setActiveDialogImportDot(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogImportDot}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          {constants.modal.importDot[language]}
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <MyDropzone
            setOpen={setActiveDialogImportDot}
            text={text[language]}
          ></MyDropzone>
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
